import { Button, Typography } from "@mui/material";

import React from "react";

type INullGenericProps = {
    title :string;
    image?: string;
    description: string | JSX.Element;
    buttonText?: string;
    handleCTA?: () => void;
    showButton?: boolean;
    isButtonDisabled?: boolean;
    contentClassName?: string;
    buttonClassName?: string;
}

const NullGeneric = (props: INullGenericProps) => {
  const { title, image, description, buttonText, handleCTA,
    showButton = true, isButtonDisabled=false, contentClassName="", buttonClassName="" } = props;


  return (
    <div className="flex flex-col gap-2 self-stretch items-center px-0 py-6 w-full h-full justify-center">
      <div className={`flex flex-col gap-2 items-center ${contentClassName}`}>
        <div className="max-w-[13.75rem]">
          <img
            src={image ? image : "/assets/icons/socNull.png"}
            alt="Empty State"
          />
        </div>
        <div className="flex flex-col gap-3 justify-center items-center text-center">
          <Typography variant="h4" className="font-semibold" >{title}</Typography>
          <Typography variant="body1">{description}</Typography>

          {showButton &&
          <Button variant="contained" disabled={isButtonDisabled} fullWidth
            className={`!normal-case !border-1 !border-gray-4 !font-bold ${buttonClassName}`}
            type="button" id="BookAVisitButton" onClick={handleCTA}>
            {buttonText ? buttonText : "Book Appointment"}</Button>}
        </div>
      </div>
    </div>
  );
};

export default NullGeneric;
